<template>
    <div class="af">
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="gsname" :label="$t('form_company')" >
                    <el-select v-model="formData.gsname" :placeholder="$t('form_please_select_a_company')" filterable required clearable disabled>
                        <el-option
                                v-for="item in companyName"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                            <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="bmname" :label="$t('form_receiving_department')" >
                    <el-select v-model="formData.bmname" :placeholder="$t('form_please_select_department')"  filterable required clearable disabled>
                        <el-option
                                v-for="itembm in groupName"
                                :key="itembm.i_id"
                                :label="itembm.vc_name"
                                :value="itembm.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="ckname" :label="$t('form_warehouse')" >
                    <el-select v-model="formData.ckname" :placeholder="$t('form_please_select_warehouse')" filterable required clearable disabled>
                        <el-option
                                v-for="one in warehouseName"
                                :key="one.i_id"
                                :label="one.vc_name"
                                :value="one.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-title" prop="sqName" :label="$t('form_applicant')" >
                    <el-select v-model="formData.sqName" :placeholder="$t('form_please_select_the_applicant')"  filterable required clearable disabled>
                        <el-option
                                v-for="itemsq in personName"
                                :key="itemsq.i_id"
                                :label="itemsq.vc_name"
                                :value="itemsq.i_id">
                        </el-option>

                    </el-select>
                </el-form-item>
                <el-form-item class="form-title num" prop="num" label="No:" >
                    <span  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                </el-form-item>
            </div>
            <div style="margin-bottom: 20px">
                <el-table class="table"
                          border
                          ref="multipleTable"
                          :data="tableData"
                          height="255"
                          size="mini"
                          :row-class-name="tableRowClassName"
                          tooltip-effect="dark"
                >
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="left"
                            type="index"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_gsname"
                            :label="$t('form_company')"
                            width="200"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_pzname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_no"
                            :label="$t('form_batch_number')"
                            width="100"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            v-if="i_pid==0"
                            align="left"
                            prop="kcsl"
                            :label="$t('form_available_stock')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            v-if="i_pid==0"
                            align="left"
                            prop="f_num"
                            :label="$t('form_quantity')"
                            width="110">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_num'" :rules="formRules.f_num">
                                <el-input-number :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_num" @change="numinput(scope.row)"></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_pid!=0"
                            align="left"
                            prop="f_num"
                            :label="$t('form_quantity')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            v-if="i_pid!=0"
                            align="left"
                            prop="f_innum"
                            :label="$t('form_confirmed_quantity')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_unit"
                            :label="$t('form_metering')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            v-if="i_pid==0"
                            align="left"
                            prop="vc_note"
                            :label="$t('form_describe')"
                            width="90">
                        <template  slot-scope="scope" >
                            <el-form-item  class="tableForm-item" :prop="scope.row.vc_note">
                                <el-input class="changeinput" size="mini" v-model="scope.row.vc_note"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_pid!=0"
                            align="left"
                            prop="vc_note"
                            :label="$t('form_describe')"
                            width="90">
                    </el-table-column>
                    <el-table-column align="center"  width="50"  v-if="i_pid==0">
                        <template slot="header" slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    placement="bottom-end"
                                    width="1000"
                                    trigger="manual"
                                    v-model="visible">
                                <template>
                                    <varieties-list v-if="visible==true" :productDetails="productDetails" @closePop="closePop" @transValue="transValue"></varieties-list>
                                </template>
                                <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                            </el-popover>
                        </template>
                        <template  slot-scope="scope">
                            <div class="iconminus">
                                <span class="minus" @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-form-item class="form-title" prop="vc_note" :label="$t('form_notes')" >
                <el-input  v-model="formData.vc_note" >
                </el-input>
            </el-form-item>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_creator')" >
                    <el-input  v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('form_date')" >
                    <el-input  v-model="formData.date" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('promanagement_accountingTime')" >
                    <el-input  v-model="formData.dt_accounttime" disabled>
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">

            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
            <!--<el-button type="primary" @click="toApprove" v-if="state==0" :disabled="disabled" :class="baseerp+'btn'">提交审批</el-button>-->
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import VarietiesList from "./VarietiesList";
    export default {
        name: "StockDetails",
        components: {VarietiesList},
        props:{
            application:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                gsname:"",
                bmname:"",
                sqName:"",
                ckname:"",
                groupid:0,
                formData:{
                    gsname:"",
                    bmname:"",
                    sqName:"",
                    ckname:"",
                    num:"000000",
                    vc_note:"",
                    kcsl:"",
                    vc_lruname:"",
                    date:"",
                    tableData:[]
                },
                formRules:{
                    f_num:[{required:true,message:this.$t('promanagement_please_fill_in_the_outbound_quantity'),trigger:"blur"},],
                },
                companyName:[],
                groupName:[],
                personName:[],
                warehouseName:[],
                tableData:[],
                f_num:"",
                visible:false,
                productDetails:{},
                vc_note:"",
                date:"",
                disabled:false,
                isbtn:false,
                edit:false,
                data:{},
                i_pid:0,
                state:0,
                qgsname:"",
                qckname:"",
                gsid:0,
                gid:0,
                i_rwid:0,
                ckid:0,
                squid:0,
                index:0,
                pageSize:1,
                baseerp:"",
                form:{},
                mid:0,
            }
        },
        watch: {
            application: {
                handler() {
                    if (this.application) {
                        this.pageSize=this.application.page_size;
                        this.i_id = this.application.i_id;
                        this.mid = this.application.i_mid;
                       // console.log(this.mid,"this.mid");
                        this.i_pid = this.application.i_pid;
                        this.i_type = this.application.i_type;
                        let dtnowtime = `${this.application.value.dt_createtime.slice(0, 4)}-${this.application.value.dt_createtime.slice(4, 6)}-${this.application.value.dt_createtime.slice(6, 8)}`;
                        let dtendtime = `${this.application.value.dt_endtime.slice(0, 4)}-${this.application.value.dt_endtime.slice(4, 6)}-${this.application.value.dt_endtime.slice(6, 8)} 23:59:59`;
                        this.formData={
                            gsname:this.application.value.vc_gsname,
                            bmname:this.application.value.vc_cjname,
                            sqName: sessionStorage.getItem("lruname"),
                            ckname:this.application.value.vc_ckname,
                            num:this.i_pid,
                            // vc_note:this.application.vc_note,
                            vc_lruname: sessionStorage.getItem("lruname"),
                            date:dtnowtime,
                            dt_accounttime:this.application.jz==false?dtendtime:dtnowtime,
                        };
                        this.gsid=this.application.value.i_gsid;
                        this.gid=this.application.value.i_cjid;
                        this.ckid=this.application.value.i_ckid;
                        if ((this.i_pid ?? '' !== '') && this.i_pid != 0) {
                            this.edit = true;
                            this.getCjReturnDetails();
                        } else if (this.i_pid == 0) {
                            this.productDetails.gsid=this.application.value.i_gsid;
                            this.productDetails.i_mid=this.mid;
                            this.productDetails.i_type=this.i_type;
                            this.productDetails.ckid=this.application.value.i_ckid;
                            this.productDetails.gsid_out=this.application.value.i_gsid_out;
                            this.productDetails.i_pzid=this.application.value.i_pzid;
                            this.productDetails.i_cjid=this.application.value.i_cjid;
                            this.productDetails.selected=[];
                            this.edit = false;
                            /*this.getCompanyList();
                            this.getGroupList();
                            this.getWarehouseList();*/
                            this.getDateYYYYMMddHHMMSS();
                        }
                       // console.log(this.application, "this.application");
                    }
                },
                immediate: true,
                deep: true
            }
        },
        mounted() {
            this.baseerp=baseerp;
            //console.log(this.application,"-----------")
        },
        methods:{
            async getCjReturnDetails(){
                let param={
                    i_mid:this.mid,
                    i_pid:this.i_pid,
                };
                let res=await API.getCjReturnDetails(param);
                if(res.code==1){
                    let data=res.data;
                   // console.log(data,"data");
                    this.formRules={};
                    this.formData={
                        gsname:data.vc_gsname,
                        bmname:data.cjname,
                        sqName:data.vc_squname,
                        ckname:data.vc_outckname,
                        num:data.i_id,
                        vc_note:data.vc_note,
                        vc_lruname:data.vc_lruname,
                        date:data.dt_createtime,
                        dt_accounttime:data.dt_accounttime,
                        tableData:data.details,
                    };
                    // this.state=data.i_state;
                    this.tableData=data.details;
                    //this.gsid=data.i_outgsid;
                    this.gsid=data.i_gsid;
                    this.gid=data.i_cjid;
                    this.squid=data.i_squid;
                    this.sqName=data.vc_squname;
                    this.i_lruid=data.i_lruid;
                    this.i_lruname=data.i_lruname;
                    //this.ckid=data.i_outckid;
                    this.ckid=data.i_ckid;
                    this.productDetails.gsid=data.i_gsid;
                    this.productDetails.i_mid=this.mid;
                    this.productDetails.ckid=data.i_ckid;
                    this.productDetails.gsid_out=data.i_gsid_out;
                    this.productDetails.i_pzid=data.i_pzid;
                    this.productDetails.i_type=data.i_type;
                    this.productDetails.selected=[];
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            numinput(value){
                if (value.f_num>value.kcsl) {
                    value.f_num=value.kcsl;
                    this.$message.error(this.$t('promanagement_the_requested_outbound_quantity_should_be_less_than_the_available_inventory'));
                    return false
                }
            },
            popShow(){
                //console.log(this.visible)
                if (this.formData.gsname==''||this.formData.ckname==''){
                    this.$message.error(this.$t('promanagement_please_select_company_or_warehouse'))
                    return
                }else if(this.formData.gsname!=''&&this.formData.ckname!=''){
                    this.visible=true;
                }
                if (this.visible==true){
                    this.isbtn=true
                }
            },
            closePop(){
                this.visible=false;
                this.isbtn=false;
            },
            //产品列表
            transValue(value){
                /*let arr=[];
                if ( this.formData.tableData.length>0){

                }else {
                     arr=[...value];
                }*/
                let arr=[...this.tableData,...value];
                // console.log(value,"------------")

                //console.log(arr,"arrrrrrrrrrrrr")
                /*const vc_pzid='vc_pzid';
                const vc_no='vc_no';
                const i_scid='i_scid';
                //console.log(item,"--item--",next)
                const newArr = arr.reduce((all,next)=>all.some((item)=>item[vc_pzid]==next[vc_pzid])?all:[...all,next],[]);
                const newArr2 = newArr.reduce((all,next)=>all.some((item)=>item[vc_no]==next[vc_no])?all:[...all,next],[]);
                const newArr3 = newArr2.reduce((all,next)=>all.some((item)=>item[i_scid]==next[i_scid])?all:[...all,next],[]);

*/
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.vc_unique] ? '' : hash[next.vc_unique] = true && item.push(next);
                    return item
                }, []);
                this.formData.tableData=arr;
                this.tableData=arr;
                this.productDetails.selected=this.tableData;
                //console.log("**arr**",newArr3)
            },
            deleteRow(value,index){
                this.index=index;
                this.tableData.splice(this.index,1);
                // console.log(value,"-----")
            },
            //提交审批
            toApprove(){
            },
            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close');

                //this.$emit('getPickingReqList')
            },
            //保存
            async saveForm(){

                let details = this.tableData.filter(item=>item.f_num!=0);
                if (details.length==0){
                    this.$message.error(this.$t('promanagement_please_add_the_requested_outbound_quantity'));
                    return ;
                }
                this.disabled=true;
                let param={
                    i_mid: this.mid,
                    i_id:this.i_pid,
                    i_rwid:this.i_id,
                    //i_outgsid:this.gsid,
                    i_gsid:this.gsid,
                    i_cjid:this.gid,
                    //i_outckid:this.ckid,
                    i_ckid:this.ckid,
                    i_squid:sessionStorage.getItem("userid"),
                    vc_squname:sessionStorage.getItem("lruname"),
                    vc_note:this.formData.vc_note,
                    details:details,
                    dt_accounttime:this.formData.dt_accounttime,
                };
                let res=await API.saveCjReturn(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.visible=false;
                    this.$emit('getCjReturnList',this.pageSize);
                    this.cancel();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
        }
    }
</script>

<style lang="scss" >
    .flex{
        display: flex;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
    }
    .num .el-form-item__label {
        color: #b3d268;
        font-size: 16px;
        font-style: italic;
    }
    .num .el-form-item__content {
        width: 130px;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .tableForm-item{
        margin: 0;
        width: 100%;
        /deep/{
            .el-form-item__content{
                width: 100%;
                margin-left: 0 !important;
            }
        }
    }
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }
    .table {
        .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
            margin-bottom: 0px;
        }
    }
    /deep/{
        .table {
            .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
                margin-bottom: 0px;
            }
        }
        .el-input__inner {
            height: 24px;
            line-height: 24px;

        }
        .cell .el-input__inner{
            height: 24px;
            line-height: 24px;
        }
        .el-table .cell{
            height: 24px;
            line-height: 24px;
        }
        .el-input-number--mini {
            width: 96px;
            line-height: 26px;
        }
        .danger-row{
            color: #999;
        }
    }

</style>
